import { CHCMedicalBanner } from './medical-banner.component.js';
export { CHCMedicalBanner };

customElements.define('chcapp-medical-banner', CHCMedicalBanner);

declare global {
  interface HTMLElementTagNameMap {
    'chcapp-medical-banner': CHCMedicalBanner;
  }
}
